import { Panel as PrimePanel } from 'primereact/panel';
import { MutableRefObject, ReactNode } from 'react';
import { PanelProps } from '../Panel';
import { ContentOnlyHeaderTemplate } from './ContentOnlyHeaderTemplate';
import { IconOnlyHeaderTemplate } from './IconOnlyHeaderTemplate';
import { TooltipHeader } from './TooltipHeader';

export function getHeaderTemplate(
    props: PanelProps,
    panelRef: MutableRefObject<PrimePanel | null>,
): ReactNode | string {
    let template = null;
    if (props.iconOnly) {
        template = IconOnlyHeaderTemplate(props, panelRef);
    }

    if (props.tooltip && template) {
        template = TooltipHeader({ header: template, ...props });
    }

    if (props.onlyContent) {
        template = ContentOnlyHeaderTemplate(props, panelRef);
    }

    return template;
}
